(function(){
 'use strict';
 if(parent===window)return;
 var received=false,ready=false,lastHeight=0;
 function shadow(){var host=document.querySelector('shopify-forms-embed');return host&&host.shadowRoot;}
 function set(field,value){
  if(!field||field.value||!value)return;
  var proto=field.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:HTMLInputElement.prototype;
  Object.getOwnPropertyDescriptor(proto,'value').set.call(field,String(value));
  field.dispatchEvent(new Event('input',{bubbles:true}));
  field.dispatchEvent(new Event('change',{bubbles:true}));
 }
 window.addEventListener('message',function(event){
  if(event.origin!==location.origin||event.source!==parent||received||!event.data||event.data.type!=='fmt-photo-prefill')return;
  var root=shadow();if(!root)return;
  received=true;
  set(root.getElementById('first_name'),String(event.data.name||'').slice(0,100));
  set(root.getElementById('email'),String(event.data.email||'').slice(0,254));
  set(root.querySelector('textarea[name="custom#how_can_we_help"]'),String(event.data.message||'').slice(0,2000));
 });
 function check(){
  var root=shadow();
  if(root&&root.getElementById('email')&&!ready){ready=true;parent.postMessage({type:'fmt-photo-ready'},location.origin);}
  var height=document.querySelector('main').getBoundingClientRect().height+32;
  if(Math.abs(height-lastHeight)>2){lastHeight=height;parent.postMessage({type:'fmt-photo-height',height:height},location.origin);}
 }
 new ResizeObserver(check).observe(document.querySelector('main'));
 var tries=0,timer=setInterval(function(){check();if(ready||++tries>60)clearInterval(timer);},500);
})();
